export function isPasswordValid(password: string): boolean {
  if (password.length < 6) {
    return false;
  }
  const hasNumber = /[0-9]/.test(password);
  // Define common symbols using a character set in regex
  const hasSymbol =
    /[\!\@\#\$\%\^\&\*\(\)\_\+\-\=\[\]\{\}\;\'\:\"\,\<\.\>\/\?\|\\~`]/.test(
      password
    );
  return hasNumber || hasSymbol;
}

export function isPasswordOneNumberSymbolValid(password: string): boolean {
  const hasNumber = /[0-9]/.test(password);
  // Define common symbols using a character set in regex
  const hasSymbol =
    /[\!\@\#\$\%\^\&\*\(\)\_\+\-\=\[\]\{\}\;\'\:\"\,\<\.\>\/\?\|\\~`]/.test(
      password
    );
  return hasNumber || hasSymbol;
}
